












import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'submitBtn'
})
export default class extends Vue {
  @Prop({ type: String, default: '' }) public type!: string;
  @Prop({ type: String, default: ''}) public width!: string;
  @Prop({ type: Boolean, default: false }) public loading!: boolean;
  @Prop({ type: Boolean, default: false }) public saveDisabled!: boolean;
  @Prop() public isCommonBtn!: boolean;
  @Prop() public isGreenBtn!: boolean;
  @Prop() public isDefault!: boolean;
  @Prop() public plain!: boolean;

  get typeClass() {
    if (this.isCommonBtn) {
      return this.plain ? 'common-btn plain' : 'common-btn';
    } else if (this.isDefault) {
      return 'default-btn';
    } else if (this.isGreenBtn) {
      return this.plain ? 'green-btn plain' : 'green-btn';
    }
    return '';
  }

  public handleBtnClick() {
    this.$emit('handle-btn-click');
  }
}
